module.exports = __webpack_public_path__ + "img/litoc_logo.5c3fa932.png";